import { FormControl } from '@mui/material'

import type { ComponentProps } from './types'

import * as S from './styles'

export const Component = ({
  name,
  label,
  error,
  required,
  disabled,
  value,
  onChange,
  onBlur,
  placeholder,
  rows = 2,
  ...rest
}: ComponentProps) => {
  return (
    <FormControl disabled={disabled} fullWidth>
      {label && (
        <S.Label disabled={disabled}>
          {label}
          {required && ' *'}
        </S.Label>
      )}

      <S.Textarea
        id={name}
        name={name}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        error={!!error}
        disabled={disabled}
        rows={2}
        {...rest}
      />

      {typeof error === 'string' && <S.ErrorMessage>{error}</S.ErrorMessage>}
    </FormControl>
  )
}
